export const APP_NAME = 'Compare';

export const MOBILE_BREAKPOINT_MAX = 719;
export const DESKTOP_BREAKPOINT_MIN = 720;
export const OLD_MOBILE_BREAKPOINT_MAX = 960;
export const DESKTOP_LG_BREAKPOINT_MIN = 1180;

export const BREADCRUMB_HEIGHT_ON_MOBILE = 30;

const NAME_PAGE = window.location.pathname.split('/')[4];
export const BASE_ROUTE = `/shop/:cc/:lc/${NAME_PAGE}`;
export const URL_PARTNUMBERS_DIVIDER = '|';
export const BAZAAR_VOICE_PASS_KEY = 'caa2W9M6aS5cNiMUWK099g7XuTDZDd7youNA0gsroteFs';
export const AVAILABILITY_TAGS_WITH_PRICES = ['ADD_TO_CART', 'PURCHASE_CD', 'NOT_AVAILABLE'];
export const DISCONTINUED = 'DISCONTINUED';
export const NOT_AVAILABLE_IN_THIS_SITE = 'NOT_AVAILABLE_IN_SITE';
export const CARTABLE_STATUSES = ['ADD_TO_CART', 'PURCHASE_CD'];
export const CALL_FOR_MORE_INFORMATION = ['NOT_AVAILABLE', 'DISCONTINUED', 'NOT_AVAILABLE_IN_SITE'];
export const DOWNLOAD = 'DOWNLOAD';
export const UNRELEASED = 'UNRELEASED';
export const COMPARISON_LOCAL_STORAGE_NAME = 'comparisonList';
export const APC_COMPARISON_SESSION_ID = 'APC_COMPARISON_SESSION_ID';

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_COPIED = 'copied';
export const NOTIFICATION_TYPE_WARNING = 'warning';
export const NOTIFICATION_TYPE_ERROR = 'error';
